module.exports = __webpack_public_path__ + "img/hardmanhall-h-474x356.88481be9.jpg";